var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwoChevronDown = function SvgTwoChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 25 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M12.09 16.5 4.59 9l1.05-1.05 6.45 6.45 6.45-6.45L19.59 9zM12.09 25.5 4.59 18l1.05-1.05 6.45 6.45 6.45-6.45L19.59 18z"
  })));
};
export default SvgTwoChevronDown;